import {get} from 'lodash';

export default (state: any, {imageType, hasError}: any) => ({
  ...state,
  businessProfileImage: {
    ...get(state, 'businessProfileImage', {}),
    [imageType]: {
      ...get(state, `businessProfileImage.${imageType}`, {}),
      hasError,
    },
  },
});
